import {Component, ElementRef, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {DomSanitizer} from '@angular/platform-browser';
import {ProjectService} from '../project/project.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  moduleId: module.id,
  template: `
    <p *ngIf="tokenError">
      Page could not be rendered. Token has expired. Try again.
    </p>
    <ng-container *ngIf="pageGenerated">
      <iframe style="width:100%;height:1000px;background-color: white;" [src]="this.sanitizer.bypassSecurityTrustResourceUrl(generateUrl())"></iframe>
      <div *ngIf="dataKeys.length>0" class="paginationComponent">

        <pagination
          [item-can-change]="true"
          [indexSelectedItem]="0"
          [item-by-page]="1"
          [total-nb-respondents]="dataKeys.length"
          (beforePageChange)="onBeforePageChange($event)"
          (go)="onBeforePageChange($event)">
        </pagination>
      </div>
    </ng-container>
  `,
  styles:[` div{background-color: white;width:100%;height:1000px;} .paginationComponent{background-color:white;width: fit-content; height:fit-content;padding-top: 100px;margin: 0 auto;}`]
})
export class MicrositeComponent implements OnInit {

  private dataKeys = [];
  private respId = 1453;
  private respToken ='sadasdasd';
  private pageGenerated = false;
  private path='';

  private token = '';
  private tokenError = false;
  // tslint:disable-next-line:no-shadowed-variable
  constructor(@Inject(DOCUMENT) private _document ,private sanitizer:DomSanitizer, private _projectService: ProjectService, private _route:ActivatedRoute,private refElement:ElementRef) {
  }

  ngOnInit(): void {
    // this._document.body.backgroundImage = 'none';
    this.refElement.nativeElement.ownerDocument
      .body.style.backgroundColor = '#FFFFFF';

    this.refElement.nativeElement.ownerDocument
      .body.style.backgroundImage = 'none';


    this._route.queryParams.subscribe(
      params=> {
        this.respId = params.respId;
        this.respToken = params.respToken;
        this.path = params.path;
      }
    );
    this.getTokenJWT();
  }

  private generateUrl():string {
    return 'http://'+window.location.hostname+':8080/'+this.path+'/microsite/site.html';
  }


  private getDataKeys() {
    this._projectService.getDataKeys(this.respId,this.token).subscribe( (val)=> {
      if(val.status!==200) {
        this.tokenError = true;
      } else {
          // If response is a JSON use json()
        this.dataKeys = (val as unknown) as Array<string>;
        this.generateMicrosite(this.dataKeys[0]);
      }
    },error1 => {
      this.tokenError = true;
    });
  }


  private generateMicrosite(key:string) {
    this._projectService.getPreview(this.respToken,false,'',key,this.token).subscribe( (val)=> {
      if(val.length>0) {
        this.pageGenerated = true;
      }
    });
  }


  onBeforePageChange($event: any) {
    if ( $event.index >= 0  ) {
      this.generateMicrosite(this.dataKeys[$event.index - 1]);
    }
  }


  getTokenJWT() {
    this._projectService.getJWTToken().subscribe( (token:string)=> {
      this.token = 'Bearer '+token;
      this.getDataKeys();
    });
  }
}
